// IF YOU CHANGE THIS FILE, YOU MUST ALSO CHANGE THE FILE IN THE NEXT LOCATIONS:
//  - portal-backend - src/modules/sitemap/localized-paths.ts

import { AvailableLocale } from '@/i18n/types'

export const en = {
    game: 'game/:game',
    category: 'category/:hru',
    tag: 'tag/:hru',
    series: 'series/:hru',
    contacts: 'contacts',
    profile: 'profile',
    shop: 'shop',
    invite: 'invite/:inviteCode',
    allCategoriesOld: 'all-categories',
    allCategories: 'all/categories',
    allTags: 'all/tags',
    allSeries: 'all/series',
    confidential: 'confidential',
    termsofuse: 'termsofuse',
    takedown_notice: 'takedown-notice',
    license: 'license',
    partners_api: 'partners-api',
}

export type LocalizedPaths = typeof en

export const es: LocalizedPaths = {
    game: 'juego/:game',
    category: 'categoria/:hru',
    tag: 'etiqueta/:hru',
    series: 'serie/:hru',
    contacts: 'contactos',
    profile: 'perfil',
    shop: 'tienda',
    invite: 'invitar/:inviteCode',
    allCategoriesOld: 'categorias-juegos',
    allCategories: 'todas/categorias',
    allTags: 'todas/etiquetas',
    allSeries: 'todas/series',
    confidential: 'confidencial',
    termsofuse: 'terminosdeuso',
    takedown_notice: 'aviso-de-eliminacion',
    license: 'licencia',
    partners_api: 'api-de-socios',
}

export const de: LocalizedPaths = {
    game: 'spiel/:game',
    category: 'kategorie/:hru',
    tag: 'tag/:hru',
    series: 'serie/:hru',
    contacts: 'kontakte',
    profile: 'profil',
    shop: 'laden',
    invite: 'einladen/:inviteCode',
    allCategoriesOld: 'alle-kategorien-alt',
    allCategories: 'alle/kategorien',
    allTags: 'alle/tags',
    allSeries: 'alle/serien',
    confidential: 'vertraulich',
    termsofuse: 'nutzungsbedingungen',
    takedown_notice: 'entfernungsmitteilung',
    license: 'lizenz',
    partners_api: 'partner-api',
}

export const fr: LocalizedPaths = {
    game: 'jeu/:game',
    category: 'categorie/:hru',
    tag: 'tag/:hru',
    series: 'serie/:hru',
    contacts: 'contacts',
    profile: 'profil',
    shop: 'boutique',
    invite: 'inviter/:inviteCode',
    allCategoriesOld: 'toutes-categories-anciennes',
    allCategories: 'toutes/categories',
    allTags: 'toutes/tags',
    allSeries: 'toutes/series',
    confidential: 'confidentiel',
    termsofuse: 'conditions-dutilisation',
    takedown_notice: 'avis-de-retrait',
    license: 'licence',
    partners_api: 'api-partenaires',
}

export const it: LocalizedPaths = {
    game: 'gioco/:game',
    category: 'categoria/:hru',
    tag: 'tag/:hru',
    series: 'serie/:hru',
    contacts: 'contatti',
    profile: 'profilo',
    shop: 'negozio',
    invite: 'invita/:inviteCode',
    allCategoriesOld: 'tutte-categorie-vecchie',
    allCategories: 'tutte/categorie',
    allTags: 'tutte/tag',
    allSeries: 'tutte/serie',
    confidential: 'riservato',
    termsofuse: 'termini-di-uso',
    takedown_notice: 'avviso-di-rimozione',
    license: 'licenza',
    partners_api: 'api-partner',
}

export const ptBr: LocalizedPaths = {
    game: 'jogo/:game',
    category: 'categoria/:hru',
    tag: 'tag/:hru',
    series: 'serie/:hru',
    contacts: 'contatos',
    profile: 'perfil',
    shop: 'loja',
    invite: 'convidar/:inviteCode',
    allCategoriesOld: 'todas-categorias-antigas',
    allCategories: 'todas/categorias',
    allTags: 'todas/tags',
    allSeries: 'todas/series',
    confidential: 'confidencial',
    termsofuse: 'termos-de-uso',
    takedown_notice: 'aviso-de-remocao',
    license: 'licenca',
    partners_api: 'api-parceiros',
}

export const allLocalizedPaths: Record<AvailableLocale, LocalizedPaths> = {
    'en-US': en,
    'es-ES': es,
    'de-DE': de,
    'fr-FR': fr,
    'it-IT': it,
    'pt-BR': ptBr,
}
